module.exports = __webpack_public_path__ + "assets/media/search-city.2e3fb3cc.svg";